"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartStorage = void 0;
var angular = require("angular");
var CartStorage = /** @class */ (function () {
    /* @ngInject */
    CartStorage.$inject = ["sdkEvents"];
    function CartStorage(sdkEvents) {
        this.sdkEvents = sdkEvents;
        this.cartData = { items: [], itemsTypes: [] };
    }
    CartStorage.prototype.saveCartDataLocally = function (newCart) {
        angular.copy(newCart, this.cartData);
    };
    CartStorage.prototype.saveCart = function (cart, origin, shouldOpenCart) {
        if (shouldOpenCart === void 0) { shouldOpenCart = true; }
        cart.extraParams = { origin: origin };
        cart.eventOptions = { shouldOpenCart: shouldOpenCart };
        delete cart.billingAddress;
        delete cart.shippingAddress;
        this.sdkEvents.broadcast('Cart.Changed', cart);
    };
    CartStorage.prototype.getCartId = function () {
        return this.cartData.cartId;
    };
    CartStorage.prototype.removeCart = function (cartId) {
        this.sdkEvents.broadcast('Cart.Cleared', { cartId: cartId });
    };
    return CartStorage;
}());
exports.CartStorage = CartStorage;
